import { createSlice } from "@reduxjs/toolkit";
import { fetchUserById, createSingleUser, deleteSingleUser, updateSingleUser, resetPassword } from "../actions/userActions";

const initialState = {
    user: [],
    loading: false,
    error: null,
    updateLoading: false, // Novo estado para o loading da atualização
    updateError: null,   // Novo estado para o erro da atualização
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserById.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.data ?? action.payload;
            })
            .addCase(fetchUserById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(resetPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                state.loading = false;
                //state.user = action.payload.data ?? action.payload;
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(createSingleUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createSingleUser.fulfilled, (state, action) => {
                state.loading = false;
                //state.user.push(action.payload);
            })
            .addCase(createSingleUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(updateSingleUser.pending, (state) => { // Casos para o updateUser
                state.updateLoading = true;
                state.updateError = null;
            })
            .addCase(updateSingleUser.fulfilled, (state, action) => {
                state.updateLoading = false;
                // Atualizar o usuário na lista (opcional, dependendo da sua necessidade)
            })
            .addCase(updateSingleUser.rejected, (state, action) => {
                state.updateLoading = false;
                state.updateError = action.payload || action.error.message;
            })
            .addCase(deleteSingleUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteSingleUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = state.users.filter(user => user.uid !== action.payload);
            })
            .addCase(deleteSingleUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export default userSlice.reducer;